import React, { useState, useEffect } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";

function TicketSettingsEdit() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        ticket_format: '',
        manual_printing: false,
        car_details: false,
        incident_notes: ''
    });

    useEffect(() => {
        fetchSetting();
    }, [id]);

    const fetchSetting = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/ticket-settings/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading setting');
            navigate('/accounts/ticket-settings-list');
        }
    };

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.put(`accounts/ticket-settings/${id}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Setting updated successfully');
            navigate('/accounts/ticket-settings-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error updating setting');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Edit Ticket Setting' />
                <Card>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label>Ticket Format</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="ticket_format"
                                            value={formData.ticket_format}
                                            onChange={handleInputChange}
                                            placeholder="e.g., TKT-{YYYY}-{NUM}"
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="mt-4">
                                        <Form.Check
                                            type="switch"
                                            id="manual_printing"
                                            name="manual_printing"
                                            label="Enable Manual Tickets Printing"
                                            checked={formData.manual_printing}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Check
                                            type="switch"
                                            id="car_details"
                                            name="car_details"
                                            label="Include Car Details (2nd Print)"
                                            checked={formData.car_details}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Form.Group>
                                        <Form.Label>Incident/Scratch Notes</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            name="incident_notes"
                                            value={formData.incident_notes}
                                            onChange={handleInputChange}
                                            placeholder="Default text for incident/scratch notes..."
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Button type="submit" variant="primary">
                                        Update Settings
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default TicketSettingsEdit;